
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import Vue from "vue";
Vue.directive("tabs-scroll", {
  inserted: (el, _binding, vnode) => {
    let isMouseDown = false;
    let startX = null;
    let scrollLeft = null;
    let navElement = null;

    const onTouchStart = (event) => {
      startX = event.touches[0].pageX - navElement.offsetLeft;
      scrollLeft = navElement.scrollLeft; 
    };
    const onTouchMove = (event) => {
      event.preventDefault();
      const x = event.touches[0].pageX - navElement.offsetLeft;
      const speed = 1; // higher number means faster scrolling
      const walk = (x - startX) * speed;
      navElement.scrollLeft = scrollLeft - walk;
    };
    const onMouseDown = (event) => {
      isMouseDown = true;
      startX = event.pageX - navElement.offsetLeft;
      scrollLeft = navElement.scrollLeft;
    };
    const onMouseUp = (event) => {
      isMouseDown = false;
    };
    const onMouseLeave = (event) => {
      isMouseDown = false;
    };
    const onMouseMove = (event) => {
      if (!isMouseDown) {
        return;
      }
      event.preventDefault();
      const x = event.pageX - navElement.offsetLeft;
      const speed = 1.5; // higher number means faster scrolling
      const walk = (x - startX) * speed;
      navElement.scrollLeft = scrollLeft - walk;
    };

    navElement = el.querySelector(".tabs-scroll");

    navElement.addEventListener(
      "mousedown",
      (event) => {
        onMouseDown(event);
      },
      false
    );
    navElement.addEventListener(
      "mouseup",
      (event) => {
        onMouseUp(event);
      },
      false
    );
    navElement.addEventListener(
      "mousemove",
      (event) => {
        onMouseMove(event);
      },
      false
    );
    navElement.addEventListener(
      "mouseleave",
      (event) => {
        onMouseLeave(event);
      },
      false
    );

    navElement.addEventListener(
      "touchstart",
      (event) => {
        onTouchStart(event);
      },
      false
    );
    navElement.addEventListener(
      "touchmove",
      (event) => {
        onTouchMove(event);
      },
      false
    );
  },
});
